import { CartaComponent } from './components/carta/carta.component';
import { CategoriesCreateComponent } from './components/categories-create/categories-create.component';
import { CategoriesEditComponent } from './components/categories-edit/categories-edit.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { CutOffComponent } from './components/cutoff/cutoff.component';
import { LoginComponent } from './components/login/login.component';
import { MainComponent } from './components/main/main.component';
import { ProductsCreateComponent } from './components/products-create/products-create.component';
import { ProductsEditComponent } from './components/products-edit/products-edit.component';
import { ProductsComponent } from './components/products/products.component';
import { SalesCreateComponent } from './components/sales-create/sales-create.component';
import { SalesEditComponent } from './components/sales-edit/sales-edit.component';
import { SalesComponent } from './components/sales/sales.component';
import { TicketComponent } from './components/ticket/ticket.component';
import { UsersCreateComponent } from './components/users-create/users-create.component';
import { UsersEditComponent } from './components/users-edit/users-edit.component';
import { UsersComponent } from './components/users/users.component';
import { ExpensesComponent } from './components/expenses/expenses.component';
import { ExpensesCreateComponent } from './components/expenses-create/expenses-create.component';
import { ExpensesEditComponent } from './components/expenses-edit/expenses-edit.component';
import { UploadCartaComponent } from './components/upload-carta/upload-carta.component'

export const ROUTES = [
  {
    path: '/',
    exact: true,
    key: 'LOGIN',
    component: LoginComponent
  },
  {
    path: '/main',
    exact: false,
    key: 'MAIN',
    component: MainComponent
  },
  {
    path: '/sales',
    exact: true,
    key: 'SALES',
    component: SalesComponent,
    policy: 'SALES::LIST'
  },
  {
    path: '/sales/new',
    exact: false,
    key: 'SALES-NEW',
    component: SalesCreateComponent,
    policy: 'SALES::CREATE'
  },
  {
    path: '/sales/:id/edit',
    exact: false,
    key: 'SALES-EDIT',
    component: SalesEditComponent,
    policy: 'SALES::EDIT'
  },
  {
    path: '/categories',
    exact: true,
    key: 'CATEGORIES',
    component: CategoriesComponent,
    policy: 'CATEGORIES::LIST'
  },
  {
    path: '/categories/new',
    exact: false,
    key: 'CATEGORIES-NEW',
    component: CategoriesCreateComponent,
    policy: 'CATEGORIES::CREATE'
  },
  {
    path: '/categories/:id/edit',
    exact: false,
    key: 'CATEGORIES-EDIT',
    component: CategoriesEditComponent,
    policy: 'CATEGORIES::EDIT'
  },
  {
    path: '/products',
    exact: true,
    key: 'PRODUCTS',
    component: ProductsComponent,
    policy: 'PRODUCTS::LIST'
  },
  {
    path: '/products/new',
    exact: false,
    key: 'PRODUCTS-NEW',
    component: ProductsCreateComponent,
    policy: 'PRODUCTS::CREATE'
  },
  {
    path: '/products/:id/edit',
    exact: false,
    key: 'PRODUCTS-EDIT',
    component: ProductsEditComponent,
    policy: 'PRODUCTS::EDIT'
  },
  {
    path: '/cutoff',
    exact: false,
    key: 'CUTOFF',
    component: CutOffComponent,
    policy: 'CUTOFF::LIST'
  },
  {
    path: '/users',
    exact: true,
    key: 'USERS',
    component: UsersComponent,
    policy: 'USERS::LIST'
  },
  {
    path: '/users/new',
    exact: false,
    key: 'USERS-NEW',
    component: UsersCreateComponent,
    policy: 'USERS::CREATE'
  },
  {
    path: '/users/:id/edit',
    exact: false,
    key: 'USERS-EDIT',
    component: UsersEditComponent,
    policy: 'USERS::EDIT'
  },
  {
    path: '/carta',
    exact: false,
    key: 'CARTA',
    component: CartaComponent
  },
  {
    path: '/ticket/:id',
    exact: false,
    key: 'TICKET',
    component: TicketComponent,
  },
  {
    path: '/expenses',
    exact: true,
    key: 'EXPENSES',
    component: ExpensesComponent
  },
  {
    path: '/expenses/new',
    exact: false,
    key: 'EXPENSES-NEW',
    component: ExpensesCreateComponent
  },
  {
    path: '/expenses/:id/edit',
    exact: false,
    key: 'EXPENSES-EDIT',
    component: ExpensesEditComponent
  },
  {
    path: '/upload',
    exact: true,
    key: 'UPLOAD',
    component: UploadCartaComponent
  }
];